const items = () => {
  return new Promise((resolve, reject) => {
    fetch("https://jsonplaceholder.typicode.com/todos")
      .then(response => response.json())
      .then(json => {
        let _items = [];
        for (let i = 0; i < json.length; i++) {
          _items = [
            ..._items,
            {
              id: json[i].id,
              img: "http://picsum.photos/200/?random",
              title: json[i].title,
              description: `user wrote this todo is ${
                json[i].userId
              } and it is ${json[i].completed ? "" : "not"} completed`,
              amount: 0
            }
          ];
        }
        console.log(_items);

        resolve(_items);
      })
      .catch(err => {
        let _items = [];
        for (let i = 0; i < 50; i++) {
          _items = [
            ..._items,
            {
              id: i,
              img: "http://picsum.photos/200/?random",
              title: `item ${i}`,
              description: "Fruits that can give you a power",
              amount: 0
            }
          ];
        }

        resolve(_items);
      });
  });
};
export default items;
